
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Badge from 'vux/src/components/badge/index.vue'


export default {
  components: {
    XHeader,
    Search,
    Tab,
    TabItem,
    ViewBox,
    Badge
  },
  data () {
    return {
      pageTitle: '待办事宜',
      value: '', // 顶部搜索内容
      results: [], // 搜索结果
      tabList: [], // 待办列表数据
      tabName: '合同', // tab页名称
      baseUrl: this.$store.state.url,
      userName: false,
      contractNum: false,
      attendanceNum: false,
      financeNum: false,
      businessNum: false,
      hrNum: false,
      otherNum: false
    }
  },
  mounted () {
    // 打开待办页面，默认显示合同待办
    this.showTodo('CONTRACT')
    if (this.$store.state.userInfo.accounts) {
      this.userName = this.$store.state.userInfo.accounts
    }
    this.getTodoNum()// 获取各类待办数量
},
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login'})
    },
    getTodoNum () { // 获取各类待办数量
      this.axios({
        url: this.baseUrl + '/wechat/todo/personal/todoCount',
        method: 'get'
      }).then((response) => {
        let numData = response.data.data
        if (numData.HR > 0) {
          this.hrNum = true
        }
        if (numData.FINANCE > 0) {
          this.financeNum = true
        }
        if (numData.ATTENDANCE > 0) {
          this.attendanceNum = true
        }
        if (numData.BUSINESS > 0) {
          this.businessNum = true
        }
        if (numData.CONTRACT > 0) {
          this.contractNum = true
        }
        if (numData.OTHER > 0) {
          this.otherNum = true
        }
      }).catch((response) => {
      })
    },
    getChange (val) {
      this.value = val
    },
    onSubmit () {
      this.$refs.search.setBlur()
      this.$vux.toast.show({
        type: 'text',
        position: 'top',
        text: 'on submit'
      })
    },
    onSearch () { // 改造cancel=>search,对列表中的数据进行筛选
      let tabListLength = this.tabList.length
      let newTabList = []
      let keyStr = this.value.trim()
      if (keyStr != '') {
        for (let i = 0; i < tabListLength; i++) {
          let searchMark = this.tabList[i].businessName.includes(keyStr)
          if (searchMark) {
            newTabList.push(this.tabList[i])
          }
        }
        this.tabList = newTabList
      } else if (keyStr == '') {
        this.changeTab(this.tabName)
      }
    },
    changeTab (v) { // 待办事宜-切换tab
      if (v === '合同') { // 合同
        this.tabName = '合同'
        this.showTodo('CONTRACT')
        this.$store.state.todoTabType = 'CONTRACT'// 回退到待办页时使用
      } else if (v === '行政') { // 行政
        this.tabName = '行政'
        this.showTodo('ATTENDANCE')
        this.$store.state.todoTabType = 'ATTENDANCE'
      } else if (v === '财务') { // 财务
        this.tabName = '财务'
        this.showTodo('FINANCE')
        this.$store.state.todoTabType = 'FINANCE'
      } else if (v === '业务') { // 业务
        this.tabName = '业务'
        this.showTodo('BUSINESS')
        this.$store.state.todoTabType = 'BUSINESS'
      } else if (v === '人力') { // 人力
        this.tabName = '人力'
        this.showTodo('HR')
        this.$store.state.todoTabType = 'HR'
      } else if (v === '其他') { // 其他
        this.tabName = '其他'
        this.showTodo('OTHER')
        this.$store.state.todoTabType = 'OTHER'
      }
    },
    showTodo (tag) { // 加载待办列表数据
      if (tag) {
        this.$vux.loading.show({
          text: '加载中'
        })
        this.axios({
          url: this.baseUrl + '/wechat/todo/personal?tag=' + tag, // 打开待办页，默认显示‘合同’
          method: 'get'
        }).then((response) => {
          let dataArr = response.data.list
          this.tabList = dataArr
          this.$vux.loading.hide()
        }).catch((response) => {
          this.$vux.loading.hide()
        })
      } else {
        this.tabList = []
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Todo.vue